export default __webpack_public_path__ + "static/Hth-9492cef1abfc875b9a4a6614bf9dc2e2.png";